import { SPECIALCHAR, LOWERCASEWORDS, UPPERCASEWORDS } from './mixedCaseModel';
export var toMixedCase = function toMixedCase(str) {
  // str should be of type 'string' but double check in case the server returns
  // unexpected values

  /* istanbul ignore next */
  var strList = typeof str === 'string' ? str.split('') : '';
  var subString = '';
  var mixedCaseString = ''; // loop through each character in strList

  for (var i = 0; i < strList.length; i++) {
    if (SPECIALCHAR[strList[i]]) {
      if (subString === '') {
        // handling edge case when 1st character in strList is special character
        mixedCaseString += strList[i];
        continue;
      }

      mixedCaseString = checkAndUpdateMinorWords(subString, mixedCaseString);
      mixedCaseString += strList[i]; // adding current element which is special character

      subString = '';
    } else {
      // if the string is 1st character in the subString, then it should be in upperCase
      var s = subString.length > 0 ? strList[i].toLowerCase() : strList[i].toUpperCase();
      subString += s;
    }
  }

  if (subString.length > 0) {
    // when loop is exited but substring is not empty
    mixedCaseString = checkAndUpdateMinorWords(subString, mixedCaseString);
  }

  return mixedCaseString;
};

var checkAndUpdateMinorWords = function checkAndUpdateMinorWords(subString, newStr) {
  if (LOWERCASEWORDS[subString]) {
    // check if substring is one of the lowercase words
    subString = subString.toLowerCase();
  } else if (UPPERCASEWORDS[subString]) {
    // check if substring is one of the uppercase words
    subString = subString.toUpperCase();
  }

  newStr += subString;
  return newStr;
};
/*
use case:
  introduction to mathematics
  Writing in science
  APPLIED COMMunications
  chemistry (ap/honors/advanced)
  statistics, ap
  us History
  biology
*/


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/mixedCase.js
// module id = 5780
// module chunks = 11